<template>
  <div>
    <div class="home-top"></div>
    <div class="home-mid">
        <div class="mid-tip">
            <div class="tips" v-for="(item,index) in middata" :key="index" @click="go(item.url)">
                <div class="tips-all" >
                    <div class="tips-top">
                        <img :src="item.logo" alt="">
                        <div><span style="position:relative">{{item.tit}}<img :src="item.src" alt=""></span></div>
                    </div>
                    <div class="tips-text">
                        {{item.text}}
                    </div>
                    <!-- <div class="tips-bot">
                        <img src="" alt="">
                    </div> -->
                    <div class="tips-bot1">
                        {{item.soft}}
                    </div>
                </div>
            </div>
        </div>
        <div class="mid-dt">
            <div class="dt-tit">公司动态</div>
            <div class="dt-txt">
                <div v-for="(item,index) in dtdata" :key="index" class="dt-item"  :style="{'cursor':!!item.url?'pointer':'auto'}">
                    <div class="dt-item-all">
                        <div class="item-time">
                            <div>{{item.time.split('-')[1]}}-{{item.time.split('-')[2]}}</div>
                            <div>{{item.time.split('-')[0]}}</div>
                        </div>
                        <div class="item-nei">
                            <div>{{item.title}}</div>
                            <div>{{item.txt}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="home-bot">
        <div class="bot-all">
            <div class="bot-tit">量化技术研究面对面</div>
            <div class="tit-text">与各界投资者面对面交流，可办讨论会、培训会等，欢迎各界投资机构在此提交预约联系我们</div>
        </div>
        <div class="bot-yuyue" @click="showform=true">
            <img src="../assets/img/bianji.png" alt="" style="position:relative;margin-right:5px;top:5px">
            <div style="position:relative;top:1px">在线预约</div>
        </div>
        <div class="bot-tel">咨询电话：<common-data name="serviceTel"/></div>
    </div>
    <formss v-if="showform" @callback="callback" ref="fs"></formss>
  </div>
</template>

<script>
import formss from "../components/formss.vue";
import commonData from '../plugins/FetchCommonData'
export default {
    data(){
        return {
            showform:false,
            middata:[
                {
                    logo:require('../assets/img/T8.png'),
                    tit:'',
                    text:'基于技术指标的趋势策略开发、自动交易，麦语言积木式编程环境、历史数据、期货交易接口。',
                    url:'/Feature/wt8',
                    src:require('../assets/img/HOT.png'),
                    soft:'',
                },
                {
                    logo:require('../assets/img/T9.png'),
                    tit:'',
                    text:'支持趋势策略、订单流策略、算法下单组件的开发，服务于金工、投资经理、交易员等各种角色的工作需求。',
                    url:'/Feature/wt9',
                    soft:'',
                },
                {
                    logo:require('../assets/img/T10.png'),
                    tit:'',
                    text:'估值数据库的应用平台，引用估值数据、技术指标、财务数据、市场情绪等各类因子，构建量化多头、市场中性等策略。',
                    url:'/Feature/wh11',
                    src:require('../assets/img/New.png'),
                    soft:'',
                },
                {
                    logo:require('../assets/img/niu.png'),
                    tit:'',
                    text:'估值数据库的应用平台，引用估值数据、宏观、盈利预期、公告事件等各类因子，构建风险控制策略。',
                    url:'/Feature/wh12',
                    src:require('../assets/img/New.png'),
                    soft:'',
                },
            ],
            dtdata:[
                // {
                //     time:'2024-09-20',
                //     title:'wh12推出股票风险控制功能',
                //     txt:'通过引用多个维度事件因子，采用贝叶斯概率算法，研究股价的波动方向，优化主观策略的净值曲线。',
                // },
                {
                    time:'2025-07-11',
                    title:'',
                    txt:'面向专业投资机构，提供集成化、全流程的风险控制策略开发工具。',
                    // url:'https://wh12.wenhua.com.cn'
                },
                // {
                //     time:'2024-05-09',
                //     title:'wh11推出事件驱动另类数据因子',
                //     txt:'囊括政策、技术、社会类大事件，以更精准捕捉市场信号，助力用户制定领先选股策略。',
                // },
                {
                    time:'2025-07-11',
                    title:'',
                    txt:'面向专业投资机构，提供集成化、全流程的量化策略开发工具。',
                    // url:'/News'
                },
            ]
        }
    },
    methods:{
        callback(bool) {
        this.showform = bool;
        },
        go(url){
            this.$router.push({path:url})
        },
        gotoNews(url){
            if(url.includes('http')){
                window.open(url,'_blank')
            }
            else{
                let routeUrl = this.$router.resolve({
                    path: '/News',
                })
                window.open(routeUrl.href, '_blank')
            }
        },
        async setCommonData(){
            this.middata[0].tit = await commonData('appFullName_11');
            this.middata[0].soft = await commonData('tollPartSoftWare');
            this.middata[1].tit = await commonData('appFullName_17');
            this.middata[1].soft = await commonData('tollPartSoftWare');
            this.middata[2].tit = await commonData('appFullName_37');
            this.middata[2].soft = await commonData('tollSoftWare');
            this.middata[3].tit = await commonData('appFullName_29');
            this.middata[3].soft = await commonData('tollSoftWare');

            this.dtdata[0].title = await commonData('appShortName_29') + await commonData('appFullName_29') + '发布';
            this.dtdata[1].title = await commonData('appShortName_37') + await commonData('appFullName_37') + '正式发布';
        }
    },
    mounted(){
        this.setCommonData()
    },
    components: {
    formss,
  },
}
</script>

<style scoped>
.home-top {
    background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=81) no-repeat center;
    height: 496px;
}
.home-mid {
    background:url(../assets/img/bg1.jpg) no-repeat top;
    height: 581px;
    padding-top: 1px;
}
.home-bot {
    overflow: hidden;
    background: url(../assets/img/bg-3.jpg) no-repeat center;
    height: 407px;
}
.mid-tip {
    display: flex;
    justify-content: space-between;
    width: 1260px;
    margin: 0 auto;
    margin-top: -75px;
    /* position: relative;
    top: -75px; */
}
.mid-dt{
    width: 1260px;
    margin: 0 auto;
    margin-top: 35px;
    background: url(../assets/img/chengshi.png) no-repeat left 60px ;
    padding-bottom: 37px;
}
.dt-tit{
    font-size: 20px;
    text-align: left;
}
.dt-txt{
    margin-left: 560px;
    margin-top: 5px;
}
.dt-item{
    padding: 33px 0;
    border-bottom: 1px  solid #dedede;
    text-align: left;
    font-size: 16px;
    cursor: pointer;
}
.dt-item:last-child{
    border:none;
}
.dt-item-all{
    display: flex;
    flex-direction: row;

}
.item-time{
    margin-right: 11px;
    width: 47px;
    white-space: nowrap;
}
/* .item-nei div:first-child:hover{
    color: #3b78f7;
} */
/* .item-nei div:last-child:hover{
    color: #3b78f7;
} */
.item-time div:first-child,.item-nei div:first-child{
   line-height: 20px;
}
.item-time div:last-child,.item-nei div:last-child{
   font-size: 14px;
   color: #7c7d7f;
   margin-top: 4px;
}
.mid-tip .tips {
    width: 310px;
    height: 286px;
    background: url(../assets/img/bg-1.png) no-repeat center;
    background-size: 100% 100%;
    position: relative;
    cursor: pointer;
    /* border-radius: 6px; */
    /* box-shadow: #d6d7db 3px 3px 6px 2px; */
    transition: all 0.5s;
    -moz-transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
}
.mid-tip .tips:hover{
    transform: scale(1.05);
}
.tips-all {
    margin: 60px 32px 0 32px;
}
.tips-top {
    display: flex;
    align-items: flex-end;
}
.tips-top div {
    margin-left: 12px;
    font-size: 20px;
    position: relative;
}
.tips-top div img{
    position: absolute;
    top: -5px;
    right:-7px;
}
.tips-text {
    color: #75767a;
    text-align: justify;
    margin-top: 25px;
    font-size: 17px;
}
.tips-bot {
    position: absolute;
    bottom: 25px;
    right: 32px;
    width: 50px;
    height: 50px;
    border-radius:50% ;
    background: url(../assets/img/jiantou.png) no-repeat center,white;
    cursor: pointer;
}
.tips-bot1{
    position: absolute;
    bottom: 25px;
    left: 32px;
    font-size: 16px;
    color: #b0afaf;
}
.bot-all {
    width: 1260px;
    margin: 0 auto;
    margin-top: 100px;
    text-align: center;
}
.bot-tit {
    font-size: 28px;
    color: white;
}
.tit-text {
    color: #d1d1cf;
    font-size: 16px;
    margin-top: 20px;
}
.bot-tel {
    color: #5876e2;
    font-size: 16px;
    margin-top: 27px;
}
.bot-yuyue {
    font-size: 16px;
    cursor: pointer;
    width: 156px;
    margin: 0 auto;
    margin-top: 65px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    display: flex;
    align-items: baseline;
    border-radius: 18px;
    background-image: linear-gradient(90deg,#88f4fe,#76cdff,#68aaff);
    background-image: -moz-linear-gradient(90deg,#88f4fe,#76cdff,#68aaff);
    justify-content: center;
    transition: all 0.5s;
    -moz-transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
}
.bot-yuyue:hover {
    background-image: linear-gradient(90deg,#68aaff,#76cdff,#88f4fe);
    background-image: -moz-linear-gradient(90deg,#68aaff,#76cdff,#88f4fe);
}
</style>